import { isSingleIssueLoaded } from './single-issue.tsx';
import { createIssueHook } from './utils.tsx';

export const useIsSingleIssueLoaded = createIssueHook(isSingleIssueLoaded);
